import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useIsLoggedInUserType from "../../../shared/hooks/useIsLoggedInUserType";
import { useSelector } from "react-redux";
import LoadingTransition from "./../../components/LoadingTransition/index";
import { USER_TYPE_MAP } from "../../../shared/utility";

const ProductSupportRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();
  const isFetchingCredentials = useSelector((state) => state.authentication.isFetching);
  let isLoggedInProductSupport = useIsLoggedInUserType(USER_TYPE_MAP.ProductSupport);

  if (isFetchingCredentials) return <LoadingTransition />;

  return isLoggedInProductSupport ? (
    <Component {...rest} />
  ) : (
    <Navigate to="/login" state={{ from: location }} />
  );
};

export default ProductSupportRoute;
